import { parsePhoneNumberWithError } from 'libphonenumber-js';

const GB_DEFAULT_COUNTRY = 'GB';

/**
 * Validates UK contact numbers for broker flows. Uses the same parse path as the backend
 * (`parsePhoneNumberWithError` with defaultCountry GB).
 */
export function isValidGbPhoneNumber(value: string | null | undefined): boolean {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) {
    return false;
  }
  try {
    return parsePhoneNumberWithError(trimmed, { defaultCountry: GB_DEFAULT_COUNTRY }).isValid();
  } catch {
    return false;
  }
}

interface GbPhoneAntdRuleOptions {
  warningOnly?: boolean;
}

/** React Hook Form validate — skips empty values so `required` can handle them. */
export function gbPhoneNumberRhfValidate(message: string) {
  return (value: unknown) => {
    const trimmed = String(value ?? '').trim();
    if (!trimmed) {
      return true;
    }
    return isValidGbPhoneNumber(trimmed) || message;
  };
}

/** Ant Design / Pro Form rule — skips empty values so `required` can handle them. */
export function gbPhoneNumberAntdRule(message: string, options?: GbPhoneAntdRuleOptions) {
  return {
    warningOnly: options?.warningOnly,
    validator: async (_: unknown, value: unknown) => {
      const trimmed = String(value ?? '').trim();
      if (!trimmed) {
        return Promise.resolve();
      }
      if (!isValidGbPhoneNumber(trimmed)) {
        return Promise.reject(new Error(message));
      }
      return Promise.resolve();
    },
  };
}
